// Contexto para anmazenar dados do ID do AutoComplete escolhido

import React, { createContext, useState } from "react";

export const TiposDocsContext = createContext()
//export const setTiposDocsNameContext = createContext()

export const TiposDocsContextProvider = ({ children }) => {
    
    const [tipoDocIdContext, setTipoDocIdContext] = useState('')
   // const [tipoDocNameContext, setTiposDocsNameContext] = useState('')

    return (
        <TiposDocsContext.Provider value={
            {
                tipoDocIdContext, setTipoDocIdContext,
     //           tipoDocNameContext, setTiposDocsNameContext,
            }
        }>
            {children}
        </TiposDocsContext.Provider>
    )
}